/* src/app/components/user/ReviewsTable/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
} from '@material-ui/core';
import { MoreHoriz, ExpandMore } from '@material-ui/icons';

import { formatDate } from '../../../../util';
import { getAverage } from '../../../../util/misc';
import { loadTexts } from '../../../../config/texts';

import styles from './styles';
const TEXT_KEY = 'components';

export class ReviewsTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: props.expanded,
      anchorEl: null,
      review: null,
      texts: loadTexts(TEXT_KEY, props.locale),
    };

    this.panelRefs = props.data.reduce(
      (acc, x) => ({ ...acc, [x._id]: React.createRef() }),
      {},
    );

    this._onChange = this._onChange.bind(this);
    this._onOpenMenu = this._onOpenMenu.bind(this);
    this._onCloseMenu = this._onCloseMenu.bind(this);
    this._onClickVisibility = this._onClickVisibility.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.expanded !== nextProps.expanded) {
      this.setState({ expanded: nextProps.expanded }, () => {
        if (this.panelRefs[nextProps.expanded])
          this.panelRefs[nextProps.expanded].current.scrollIntoView();
      });
    }
  }

  _onChange(_id) {
    return (event, expanded) => {
      this.setState({ expanded: expanded ? _id : false });
    };
  }

  _onOpenMenu(review) {
    return (event) => {
      this.setState({ anchorEl: event.currentTarget, review });
    };
  }

  _onCloseMenu() {
    this.setState({ anchorEl: null });
  }

  _onClickVisibility() {
    const { review } = this.state;
    this.props.onClickVisibility(review);
    this.setState({ anchorEl: null, review: null });
  }

  renderSummary(classes, { name, date, textFields, numericFields, _id }, i, expanded) {
    const {
      texts: { review },
    } = this.state;
    const toFrom = this.props.type === 'student' ? review.to : review.from;

    return (
      <ExpansionPanelSummary
        expandIcon={<ExpandMore />}
        classes={{ content: classes.contentOverride }}
      >
        <div className={classes.withComment}>
          <div className={classes.headerText}>
            <Typography>
              {toFrom}: {name}
            </Typography>
            <Typography>{date.format('MMM D, Y')}</Typography>
            {numericFields.length > 0 && (
              <Typography align="left">
                {review.average_rate}: {getAverage(numericFields).toFixed(2)}
              </Typography>
            )}
          </div>
          {expanded !== _id && (
            <Typography color="textSecondary" noWrap>
              {get(textFields, '0.value', '')}
            </Typography>
          )}
        </div>
      </ExpansionPanelSummary>
    );
  }

  renderDetails(classes, review) {
    const { rating, comment } = review;
    const { numericFields, textFields } = review;
    const { texts } = this.state;

    return (
      <ExpansionPanelDetails classes={{ root: classes.detailRoot }}>
        <div className={classes.comment}>
          <div className={classes.textsContainer}>
            {textFields.map((field) => (
              <Typography key={field.name} paragraph color="textSecondary">
                {field.value || ''}
              </Typography>
            ))}
          </div>
          <IconButton onClick={this._onOpenMenu(review)}>
            <MoreHoriz />
          </IconButton>
        </div>
        {numericFields.length > 0 && (
          <div className={classes.comment}>
            {numericFields.map(field => (
              <Typography key={field.name}>
                {field.name}: {field.value}
              </Typography>
            ))}
          </div>
        )}
      </ExpansionPanelDetails>
    );
  }

  render() {
    const { classes, data } = this.props;
    const { expanded, anchorEl, review, texts } = this.state;
    return (
      <React.Fragment>
        <Table>
          <TableHead>
            <TableRow className={classes.header}>
              <TableCell>{texts.review.comments}</TableCell>
            </TableRow>
          </TableHead>
        </Table>
        <div className={classes.root}>
          {data.map((datum, i) => (
            <div
              ref={this.panelRefs[datum._id]}
              className={classNames({
                [classes.expanded]: expanded === datum._id,
              })}
              key={datum._id}
            >
              <ExpansionPanel
                expanded={expanded === datum._id}
                onChange={this._onChange(datum._id)}
              >
                {this.renderSummary(classes, datum, i, expanded)}
                {this.renderDetails(classes, datum)}
              </ExpansionPanel>
            </div>
          ))}
        </div>
        <Menu
          id="review-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this._onCloseMenu}
        >
          <MenuItem onClick={this._onClickVisibility}>
            {review
              ? review.visible
                ? texts.review.hide
                : texts.review.unhide
              : texts.review.hide}
          </MenuItem>
        </Menu>
      </React.Fragment>
    );
  }
}

ReviewsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  type: PropTypes.oneOf(['student', 'tutor']).isRequired,
  onClickVisibility: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  locale: state.appState.locale,
});

export default compose(
  withStyles(styles, { name: 'ReviewsTable' }),
  connect(mapStateToProps, {}),
)(ReviewsTable);



// WEBPACK FOOTER //
// ./src/app/components/user/ReviewsTable/index.js